/**
 * Input component
 *
 * Optional props:
 * disabled : boolean
 * checked : boolean
 * inline : boolean
 *
 * Examples of component:
 * <Radio name="the_name" value="1" inline />
 * <Radio name="the_name" value="1" disabled />
 *
 */

import React from 'react';
import styled from 'styled-components';
import { colors } from '../../variables';

const getDisplay = props => {
	if (props.inline) return 'inline';
	return 'block';
};

const RadioContainer = styled.div`
	display: ${props => getDisplay(props)};
`;

const disabledColor = '#cecfcf';

const Input = styled.input`
	display: none;

	+ span {
		position: relative;
		display: inline-block;
		width: 16px;
		height: 16px;
		background: #fff;
		border: 2px solid ${colors.grey.graphite};
		transition: border-color 0.2s ease-out;
		border-radius: 100%;
		cursor: pointer;
		margin-right: 5px;

		&:after {
			position: absolute;
			content: '';
			display: block;
			border-radius: 100%;
			height: 7px;
			width: 7px;
			top: 50%;
			left: 50%;
			transform: translate(-50%, -50%);
			background-color: transparent;
			transition: background-color 0.2s ease-out;
		}
	}

	&:checked + span {
		border-color: ${colors.blue.digital};

		&:after {
			background-color: ${colors.blue.digital};
		}
	}

	&:disabled + span {
		border-color: ${disabledColor};
		cursor: auto;
	}

	&:disabled:checked + span {
		border-color: ${disabledColor};

		&:after {
			background-color: ${disabledColor};
		}
	}
`;

class Radio extends React.Component {
	render() {
		const { meta, input, className, inline, ...rest } = this.props;

		return (
			<RadioContainer className={className} inline={inline}>
				<label>
					<Input type="radio" {...rest} {...input} />
					<span {...rest} {...input} />
				</label>
			</RadioContainer>
		);
	}
}

export default Radio;



// WEBPACK FOOTER //
// ./src/components/Common/Radio/Radio.js